import { useContext, useEffect, useMemo } from "react";
import { PageWrapperContext } from "common/Home/PageWrapper/PageWrapper.context.tsx";
import { HeaderFilters } from "@shared/types";
import { PageWrapperFiltersContext } from "common/Home/PageWrapper/PageWrapperFilters.context.ts";
import { useFreezeContext } from "common/Home/MobileHome/DelayedFreeze.tsx";

interface UsePageWrapperProps {
  filters?: HeaderFilters;
  showSearch: boolean;
  dependencies?: any[];
  hideMobileFilters?: boolean;
  skip?: boolean;
}

const usePageWrapper = ({
  filters,
  showSearch,
  dependencies,
  hideMobileFilters,
  skip,
}: UsePageWrapperProps) => {
  const { setShowSearch, setSearchValue, setHideMobileFilters } =
    useContext(PageWrapperContext) || {};
  const { setFilters } = useContext(PageWrapperFiltersContext) || {};
  const { freezing } = useFreezeContext();

  const deps = useMemo(
    () => [...(dependencies || []), freezing],
    [...(dependencies || []), freezing]
  );

  useEffect(() => {
    if (!skip && !freezing) {
      filters && setFilters?.(filters);
      setSearchValue?.("");
      setShowSearch?.(showSearch);
      setHideMobileFilters?.(!!hideMobileFilters);

      return () => {
        setFilters?.(undefined);
        setHideMobileFilters?.(false);
        setSearchValue?.("");
        setShowSearch?.(false);
      };
    }
  }, deps);
};

export default usePageWrapper;
